import { createSlice } from '@reduxjs/toolkit';

export type channelPlaylistState = {
  channels: Record<string, any>; // Update type to store video objects directly within channel objects
};

const initialState: channelPlaylistState = {
  channels: {}
};

const ChannelPlaylistSlice = createSlice({
  name: 'channel-playlist-data',
  initialState: initialState,
  reducers: {
    addVideoToPlaylists(state, action) {
      const { channelhashId, videos } = action.payload;
      state.channels[channelhashId] = videos;
    },
    updateVideoById(state, action) {
      const { videoId, updatedVideo } = action.payload;

      // Iterate through all channels
      Object.keys(state.channels).forEach((channelhashId) => {
        const videos = state.channels[channelhashId];

        // Find and update the video with the matching videoId
        state.channels[channelhashId] = videos.map((video: any) =>
          video.id === videoId ? { ...video, ...updatedVideo } : video
        );
      });
    }
  }
});

export const { addVideoToPlaylists, updateVideoById } = ChannelPlaylistSlice.actions;

export const channelPlaylistReducers = ChannelPlaylistSlice.reducer;
